import * as React from "react";
import { Typography } from "@mui/material";
import { Input } from "antd";
import { LOGIN_OTP_LENGTH } from "../../login.constants";
import { LoginFormErrors } from "../../login.types";

interface OtpLoginStepProps {
    email: string;
    otp: string;
    otpFieldKey: number;
    formErrors: LoginFormErrors;
    isSubmitting: boolean;
    otpHintClass: string;
    otpInputWrapperClass: string;
    otpFieldErrorClass: string;
    onOtpChange: (value: string) => void;
    onClearOtpError: () => void;
    onEnterSubmit: () => void;
}

export const OtpLoginStep: React.FC<OtpLoginStepProps> = ({
    email,
    otp,
    otpFieldKey,
    formErrors,
    isSubmitting,
    otpHintClass,
    otpInputWrapperClass,
    otpFieldErrorClass,
    onOtpChange,
    onClearOtpError,
    onEnterSubmit,
}) => {
    const hasOtpError = Boolean(formErrors.otp);
    const isOtpComplete = otp.replace(/\D/g, "").length === LOGIN_OTP_LENGTH;

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && isOtpComplete && !isSubmitting) {
            e.preventDefault();
            onEnterSubmit();
        }
    };

    return (
        <>
            <Typography className={otpHintClass}>
                We sent a code to <strong>{email.trim()}</strong>
            </Typography>
            <div
                className={otpInputWrapperClass}
                onKeyDown={handleKeyDown}
            >
                <Input.OTP
                    key={otpFieldKey}
                    length={LOGIN_OTP_LENGTH}
                    value={otp}
                    disabled={isSubmitting}
                    status={hasOtpError ? "error" : undefined}
                    inputMode="numeric"
                    autoFocus
                    formatter={(digit) => digit.replace(/\D/g, "")}
                    onInput={(cells) => {
                        onOtpChange(cells.join(""));
                        onClearOtpError();
                    }}
                />
            </div>
            {formErrors.otp && (
                <Typography className={otpFieldErrorClass} component="p">
                    {formErrors.otp}
                </Typography>
            )}
        </>
    );
};
